<template>
  <ConclusionStep
    data-testid="suggestion-conclusion"
    class="suggestion-conclusion"
    status="positive"
    :title="`${title} solicitado`"
    @close="goBack"
  >
    <main class="suggestion-conclusion__content">
      <SuggestionDetails
        :suggestion-details="suggestionDetails"
        :is-investment="isInvestment"
      />
    </main>
    <template #button-primary>
      <ButtonPrimary
        label="Voltar para sugestões de parceiros"
        size="large"
        @click="goBack"
      />
    </template>
  </ConclusionStep>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { ConclusionStep, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { SuggestionDetails } from '../SuggestionDetails';
import { EInvestmentSuggestionsSteps } from '@/modules/wealth/views/InvestmentSuggestions/helpers';
import { IGetSuggestionDetailsResponse } from '@/modules/wealth/services/investment-suggestions';

@Component({
  components: {
    ConclusionStep,
    SuggestionDetails,
    ButtonPrimary
  }
})
export default class SuggestionConclusion extends Vue {
  @Prop({ type: Object, required: true })
  private suggestionDetails!: IGetSuggestionDetailsResponse;

  @Emit('change-step')
  emitChangeStep(_step: EInvestmentSuggestionsSteps) {}

  get isInvestment() {
    return this.suggestionDetails.transaction.direction === 'Investment';
  }

  get title() {
    return this.isInvestment ? 'Investimento' : 'Resgate';
  }

  goBack() {
    this.emitChangeStep(EInvestmentSuggestionsSteps.VIEW);
  }
}
</script>

<style lang="less" scoped>
.suggestion-conclusion {
  /deep/ .conclusion-step__title {
    max-width: 380px;
    margin: auto auto @size-spacing-x600;
    text-align: center;
  }

  &__content {
    max-width: 488px;
    margin: auto;
  }
}
</style>
